<div class="login-body">
    <div class="login-panel surface-card p-6 shadow-2 border-round w-full lg:w-3">
        <form #passForm="ngForm"
              *ngIf="mostrarFormRequest"
              (ngSubmit)="confirmarResetContrasenia()"
              [ngClass]="{'disabledForm': false}"
              autocomplete="false">
            <div class="text-center mb-5">
                <img src="assets/layout/images/login/logo-login.png" alt="{{appConfig.app.name}}" height="100h" class="mb-3 responsive">
                <div class="text-600 text-3xl font-medium mb-3">{{'Restablece tu contraseña rápidamente..'}}</div>
                <span class="text-600 font-medium line-height-3 uppercase">Ingresa tus <strong>credenciales</strong></span><br>
            </div>
            <div class="p-fluid p-formgrid grid">
                <p-messages [(value)]="msgs"></p-messages>
                <div class="field col-12">
                    <label for="cirucfrm">CI/RUC</label>
                    <span class="p-input-icon-left">
                        <i class="pi pi-id-card"></i>
                        <input
                            #cirucfrm="ngModel"  id="cirucfrm" name="cirucfrm"
                            type="text"
                            [(ngModel)]="user.code"
                            [pattern]="appConfig['validationRegExp']['cirucPattern']"
                            [minlength]="appConfig.ux.minlengthCIRUC" [maxlength]="appConfig.ux.maxlengthCIRUC"
                            required
                            pInputText/>
                    </span>
                    <p-message
                        severity="error"
                        [text]="appConfig['validationMsgs']['cirucPattern']"
                        *ngIf="passForm.controls['cirucfrm'] &&
                        !passForm.controls['cirucfrm'].valid &&
                        (passForm.controls['cirucfrm'].dirty ||
                        passForm.controls['cirucfrm'].touched)">
                    </p-message>
                </div>
                <div class="field col-12">
                    <label for="emailfrm">Correo electrónico</label>
                    <span class="p-input-icon-left">
                        <i class="pi pi-envelope"></i>
                        <input
                            #emailfrm="ngModel" id="emailfrm" name="emailfrm"
                            type="text"
                            [(ngModel)]="user.email"
                            [pattern]="appConfig['validationRegExp']['emailPattern']"
                            autocomplete="false"
                            required
                            pInputText/>
                    </span>
                    <p-message
                        severity="error"
                        [text]="appConfig['validationMsgs']['emailPattern']"
                        *ngIf="passForm.controls['emailfrm'] &&
                        !passForm.controls['emailfrm'].valid &&
                        (passForm.controls['emailfrm'].dirty ||
                        passForm.controls['emailfrm'].touched)">
                    </p-message>
                </div>
                <div class="field col-12">
                    <button pButton pRipple 
                            type="submit"
                            label="{{'ENVIAR'}}"
                            icon="pi pi-send" class="w-full" 
                            [disabled]="!passForm.valid">
                    </button>
                </div>
            </div>
        </form>
        <form #codeForm="ngForm"
              *ngIf="mostrarFormCode"
              (ngSubmit)="verificarCodigoVerificacion()"
              [ngClass]="{'disabledForm': false}">
            <div class="text-center mb-5">
                <img src="assets/layout/images/login/logo-login.png" alt="{{appConfig.app.name}}" height="100h" class="mb-3">
                <div class="text-900 text-3xl font-medium mb-3">¡Esperando código de confirmación!</div>
                <span class="text-600 font-medium line-height-3">Te hemos enviado un <strong>código de 6 dígitos a</strong></span><br>
                <span class="text-600 font-medium line-height-3">
                    {{user.email.substring(0, 1)}}{{user.email.length > 1 ? '*****' : ''}}{{user.email.substring(user.email.indexOf("@"), user.email.length)}}
                </span><br>
                <span class="text-100 font-light line-height-3">Si no ves el email en tu buzón, mira en la carpeta de spam.</span>
            </div>
            <p-messages [(value)]="msgs"></p-messages>
            <div class="p-fluid p-formgrid grid">
                <div *ngIf="intentos < 3"
                     class="field col-12">
                    <label for="codefrm">Código de 6 dígitos</label>
                    <span class="p-input-icon-left">
                        <i class="pi pi-id-card"></i>
                        <input
                            #codefrm="ngModel"  id="codefrm" name="codefrm"
                            type="text"
                            [(ngModel)]="codigoVerificacion"
                            [pattern]="appConfig['validationRegExp']['numberPattern']"
                            minlength="6" maxlength="6"
                            required
                            pInputText/>
                    </span>
                    <p-message
                        severity="error"
                        [text]="appConfig['validationMsgs']['numberPattern']"
                        *ngIf="codigoVerificacion &&
                        codeForm.controls['codefrm'] &&
                        !codeForm.controls['codefrm'].valid &&
                        (codeForm.controls['codefrm'].dirty ||
                        codeForm.controls['codefrm'].touched)">
                    </p-message>
                </div>
                <div class="field col-12">
                    <button *ngIf="!dataValid && intentos < 3"
                            pButton pRipple 
                            type="button"
                            label="{{'VOLVER A INTENTARLO'}}"
                            icon="pi pi-replay" class="w-full p-button-danger p-button-text p-button-rounded" 
                            (click)="resetCodeVerificacion();">
                    </button>
                    <button *ngIf="dataValid"
                            pButton pRipple 
                            type="submit"
                            label="{{'ENVIAR CONFIRMACIÓN'}}"
                            icon="pi pi-send" class="w-full p-button-rounded" 
                            [disabled]="!codeForm.valid">
                    </button>
                </div>
            </div>
            <button pButton pRipple 
                    label="IR A INICIO" 
                    icon="pi pi-home" 
                    class="w-full" style="background-color: #1f2e4d; color: white;"
                    (click)="irALogin($event);">
            </button>
        </form>
    </div>
</div>
<!---------------------------------------------->
<!------Ventanas de confirmaciones modales------>
<!---------------------------------------------->
<p-confirmDialog #cd 
                 header="{{appConfig.ux.confirmMsg}}" 
                 icon="pi pi-exclamation-triangle">
    <ng-template pTemplate="footer">
        <button pButton pRipple
                type="button" 
                label="{{appConfig.ux.confirmFalse}}"
                icon="pi pi-times" class="p-button-secondary"
                (click)="cd.reject()">
        </button>
        <button pButton pRipple
                type="button" 
                label="{{appConfig.ux.confirmTrue}}"
                icon="pi pi-check" class="ml-1"
                (click)="cd.accept()">
        </button>
    </ng-template>
</p-confirmDialog>
<!--Ventana de espera de procesamiento-->
<p-dialog [(visible)]="procesando" 
          modal="modal" showEffect="fade" 
          [breakpoints]="{ '960px': '90vw', '640px': '100vw' }"
          [style]="{ width: '90vw' }"
          (onHide)="procesando=false;">
    <ng-template pTemplate="header">
        <h4>{{appConfig.ux.loadingMsg}}</h4>
    </ng-template>
    <ng-template pTemplate="content">
        <p-progressBar mode="indeterminate"></p-progressBar> 
    </ng-template>
    <ng-template pTemplate="footer">
        <span class="uppercase">{{appConfig.app.name}}</span>
    </ng-template>
</p-dialog>
<!--Ventana de resultData-->
<p-dialog [(visible)]="mostrarResultData" 
          modal="modal" showEffect="fade" 
          [breakpoints]="{ '960px': '25vw', '640px': '35vw' }" 
          [style]="{ width: '25vw' }"
          (onHide)="mostrarResultData=false;">
    <ng-template pTemplate="header">
        <h4>{{resultData['header']}}</h4>
    </ng-template>
    <ng-template pTemplate="content">
        <div class="inline-flex">
            <i [class]="(resultData['type'] && resultData['type'].includes('success')) ? 'pi pi-check-square text-6xl' : 'pi pi-exclamation-triangle text-6xl'"></i>
            <span class="ml-1 align-self-center">{{resultData['body']}}</span>
        </div>
    </ng-template>
    <ng-template pTemplate="footer">
        <div class="flex align-items-center justify-content-center">
            <button *ngFor="let item of resultDataButtons let i = index" 
                    pButton pRipple
                    type="button" 
                    [label]="item.text"
                    [icon]="item.icon"
                    [class]="item.cssClass"
                    (click)="ejecutarAccionResult($event, item.action, null)"
                    [disabled]="item.disabled">
            </button>
        </div>
    </ng-template>
</p-dialog>
<!--Ventana de espera de verificacion-->
<p-dialog [(visible)]="verificando"
          modal="modal" showEffect="fade"
          [breakpoints]="{ '960px': '15vw', '640px': '20vw' }" 
          [style]="{ width: '15vw' }"
          [closable]="false"
          (onHide)="verificando = false"
          class="text-center">
    <ng-template pTemplate="header">
    </ng-template>
    <ng-template pTemplate="content">
        <h6>{{verificandoData['body']}}</h6>
        <i class="pi pi-spin pi-spinner text-orange-400 text-8xl"></i>
    </ng-template>
    <ng-template pTemplate="footer">
        <span class="p-text-uppercase">{{ appConfig.app.name }}</span>
    </ng-template>
</p-dialog>
